import { createSlice } from "@reduxjs/toolkit";
import {
  getFrasesConfirmacionThunk,
  createMultipleFrasesConfirmacionThunk,
  getFraseConfirmacionByIdThunk,
  updateFraseConfirmacionThunk,
  toggleFraseConfirmacionActiveThunk,
} from "./frasesConfirmacion.thunks";

const initialState = {
  list: [],
  loading: false,
  error: null,
  page: 1,
  pageSize: 10,
  totalPages: 1,
  count: 0,
  next: null,
  previous: null,
  maxPageReached: 1,
  search: "",
  talentoFilter: "",
  preguntaFilter: "",

  selectedFrase: null,
  selectedFraseLoading: false,
  selectedFraseError: null,
  viewModalOpen: false,

  formModalOpen: false,
  formMode: "create", // "create" | "edit"
  formLoading: false,
  formError: null,

  confirmModalOpen: false,
  toggleFraseId: null,
  toggling: false,
};

const frasesConfirmacionSlice = createSlice({
  name: "frasesConfirmacion",
  initialState,
  reducers: {
    clearFrasesConfirmacionError: (state) => {
      state.error = null;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setSearch: (state, action) => {
      state.search = action.payload;
      state.page = 1;
    },
    setTalentoFilter: (state, action) => {
      state.talentoFilter = action.payload;
      state.page = 1;
    },
    setPreguntaFilter: (state, action) => {
      state.preguntaFilter = action.payload;
      state.page = 1;
    },
    clearFilters: (state) => {
      state.search = "";
      state.talentoFilter = "";
      state.preguntaFilter = "";
      state.page = 1;
    },
    openViewModal: (state) => {
      state.viewModalOpen = true;
    },
    closeViewModal: (state) => {
      state.viewModalOpen = false;
      state.selectedFrase = null;
    },
    openFormModal: (state, action) => {
      state.formModalOpen = true;
      state.formMode = action.payload?.mode || "create";
      if (action.payload?.frase) {
        state.selectedFrase = action.payload.frase;
      }
      state.formError = null;
    },
    closeFormModal: (state) => {
      state.formModalOpen = false;
      state.selectedFrase = null;
      state.formError = null;
    },
    openConfirmToggle: (state, action) => {
      state.confirmModalOpen = true;
      state.toggleFraseId = action.payload.id;
    },
    closeConfirmToggle: (state) => {
      state.confirmModalOpen = false;
      state.toggleFraseId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // GET ALL
      .addCase(getFrasesConfirmacionThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFrasesConfirmacionThunk.fulfilled, (state, action) => {
        const { results, count, next, previous } = action.payload;

        state.loading = false;
        state.list = results;
        state.count = count;
        state.next = next;
        state.previous = previous;

        state.maxPageReached = Math.max(state.maxPageReached, state.page);
      })
      .addCase(getFrasesConfirmacionThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // CREATE MULTIPLE
      .addCase(createMultipleFrasesConfirmacionThunk.pending, (state) => {
        state.formLoading = true;
        state.formError = null;
      })
      .addCase(createMultipleFrasesConfirmacionThunk.fulfilled, (state) => {
        state.formLoading = false;
        state.formModalOpen = false;
      })
      .addCase(createMultipleFrasesConfirmacionThunk.rejected, (state, action) => {
        state.formLoading = false;
        state.formError = action.payload;
      })

      // GET BY ID
      .addCase(getFraseConfirmacionByIdThunk.pending, (state) => {
        state.selectedFraseLoading = true;
        state.selectedFraseError = null;
      })
      .addCase(getFraseConfirmacionByIdThunk.fulfilled, (state, action) => {
        state.selectedFraseLoading = false;
        state.selectedFrase = action.payload;
      })
      .addCase(getFraseConfirmacionByIdThunk.rejected, (state, action) => {
        state.selectedFraseLoading = false;
        state.selectedFraseError = action.payload;
      })

      // UPDATE
      .addCase(updateFraseConfirmacionThunk.pending, (state) => {
        state.formLoading = true;
        state.formError = null;
      })
      .addCase(updateFraseConfirmacionThunk.fulfilled, (state, action) => {
        state.formLoading = false;
        const index = state.list.findIndex((f) => f.id === action.payload.id);
        if (index !== -1) {
          state.list[index] = action.payload;
        }
        state.formModalOpen = false;
      })
      .addCase(updateFraseConfirmacionThunk.rejected, (state, action) => {
        state.formLoading = false;
        state.formError = action.payload;
      })

      // TOGGLE ACTIVE
      .addCase(toggleFraseConfirmacionActiveThunk.pending, (state) => {
        state.toggling = true;
      })
      .addCase(toggleFraseConfirmacionActiveThunk.fulfilled, (state, action) => {
        state.toggling = false;
        state.confirmModalOpen = false;
        const index = state.list.findIndex((f) => f.id === action.payload.id);
        if (index !== -1) {
          state.list[index] = action.payload;
        }
      })
      .addCase(toggleFraseConfirmacionActiveThunk.rejected, (state, action) => {
        state.toggling = false;
        state.error = action.payload;
      });
  },
});

export const {
  clearFrasesConfirmacionError,
  setPage,
  setSearch,
  setTalentoFilter,
  setPreguntaFilter,
  clearFilters,
  openViewModal,
  closeViewModal,
  openFormModal,
  closeFormModal,
  openConfirmToggle,
  closeConfirmToggle,
} = frasesConfirmacionSlice.actions;

export default frasesConfirmacionSlice.reducer;
